module.exports = __webpack_public_path__ + "media/assets/good_at/vue-30ce6a660aa5562d0a938416fddbef14.png";